import { TextareaAutosize } from '@material-ui/core';
import styled, { css } from 'styled-components';

export const StyledTextArea = styled(TextareaAutosize)`
  font-family: inherit;
  color: ${(props) => props.color ?? 'inherit'};
  font-size: ${(props) => props.fontSize ?? 'inherit'};
  width: ${(props) => props.width ?? 'auto'};
  border: none;
  outline: none;
  resize: none;

  padding-top: 0;

  ${(props) =>
    props.error &&
    css`
      outline-color: red;
      outline-width: 1px;
    `}

  &:focus {
    border: none;
    outline: none;
  }
`;
